import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../components/Button";
import { forword, deliveryHoldComment } from "../../actions/studensts";
import AlertDenger from "../../components/AlertDenger";
import AlertSuccess from "../../components/AlertSuccess";
import Loading from "../../components/Loading";
import InfoRow from "../../components/InfoRow";
import EnrollmentLetterField from "../../components/EnrollmentLetterField";
import TopAchieverField from "../../components/TopAchieverField";
import UNAUTHORIZED from "../UNAUTHORIZED";
import MoheReceiverModal from "../../components/MoheReceiverModal";

export default function StudentDeliver() {
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showDengerAlert, setShowDengerAlert] = useState(false);
  const [text, setText] = useState("");
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading4, setLoading4] = useState(false);
  const user = JSON.parse(localStorage.getItem("profile")).value[0].role;
  const location = useLocation();
  const navigate = useNavigate();
  const studentType = location.pathname.split("/")[3];

  const element = location.state;

  // Local state for delivery hold comment/reason (updated after save)
  const [holdComment, setHoldComment] = useState(element.delivery_hold || "");
  const [holdReason, setHoldReason] = useState(element.delivery_hold_reason || "");

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [modalComment, setModalComment] = useState(holdComment);
  const [modalReason, setModalReason] = useState(holdReason);
  const [modalLoading, setModalLoading] = useState(false);
  const [modalError, setModalError] = useState("");

  // MOHE Validation receiver modal
  const [showReceiverModal, setShowReceiverModal] = useState(false);
  const [receiverError, setReceiverError] = useState("");

  if (showSuccessAlert || showDengerAlert) {
    setTimeout(function () {
      setShowSuccessAlert(false);
      setShowDengerAlert(false);
      setLoading1(false);
      setLoading2(false);
      setLoading3(false);
      setLoading4(false);
    }, 2000);
  }

  const openModal = () => {
    setModalComment(holdComment);
    setModalReason(holdReason);
    setModalError("");
    setShowModal(true);
  };

  const handleSaveComment = async () => {
    if (!modalReason) {
      setModalError("Please select a Reason");
      return;
    }
    if (!modalComment) {
      setModalError("Can't save without a Comment");
      return;
    }
    setModalLoading(true);
    setModalError("");
    const res = await deliveryHoldComment(
      element.id,
      modalComment,
      modalReason,
      JSON.parse(localStorage.getItem("profile"))?.value[0].username,
    );
    setModalLoading(false);
    if (res.status === 200) {
      setHoldComment(modalComment);
      setHoldReason(modalReason);
      setShowModal(false);
      setShowSuccessAlert(true);
      setText(res.data.message);
    } else {
      setModalError(res.data.ERROR || "Failed to save");
    }
  };

  const openReceiverModal = () => {
    setReceiverError("");
    setShowReceiverModal(true);
  };

  const handleForward = async (receiver) => {
    setLoading2(true);
    setReceiverError("");
    const res = await forword(
      element.id,
      "deliver/",
      "mohe_validation",
      JSON.parse(localStorage.getItem("profile"))?.value[0].username,
      receiver,
    );
    if (res?.status === 200) {
      setShowReceiverModal(false);
      setShowSuccessAlert(true);
      setText(res.data.message);
    } else {
      setLoading2(false);
      setReceiverError(res?.data?.ERROR || "Failed to transfer student");
    }
  };

  const handleForwardOnsite = async () => {
    setLoading1(true);
    const res = await forword(
      element.id,
      "deliver/",
      "deliver_onsite",
      JSON.parse(localStorage.getItem("profile"))?.value[0].username,
    );
    if (res.status === 200) {
      setShowSuccessAlert(true);
      setText(res.data.message);
    } else {
      setShowDengerAlert(true);
      setText(res.data.ERROR);
    }
  };

  const handleReturnToHold = async () => {
    setLoading4(true);
    const res = await forword(
      element.id,
      "deliver/",
      "delivery_hold",
      JSON.parse(localStorage.getItem("profile"))?.value[0].username,
    );
    if (res.status === 200) {
      setShowSuccessAlert(true);
      setText(res.data.message);
    } else {
      setShowDengerAlert(true);
      setText(res.data.ERROR);
    }
  };

  const handleForwardAramex = async () => {
    setLoading3(true);
    const res = await forword(
      element.id,
      "deliver/",
      "aramex",
      JSON.parse(localStorage.getItem("profile"))?.value[0].username,
    );
    if (res.status === 200) {
      setShowSuccessAlert(true);
      setText(res.data.message);
    } else {
      setShowDengerAlert(true);
      setText(res.data.ERROR);
    }
  };

  return (
    <div>
      {user !== "user" && user !== "admin" ? (
        <UNAUTHORIZED />
      ) : (
        <div className="flex justify-center">
          <div
            className="lg:w-3/5 md:w-3/4 w-full border shadow
    flex flex-col p-3 rounded-lg bg-gray-50"
          >
            <div className="flex items-center justify-between">
              <span className="text-xl">Student Information</span>
              <span
                className="cursor-pointer rounded-full w-9 h-9 bg-red-400 text-white 
        flex items-center justify-center active:scale-90 hover:bg-red-500"
                onClick={() => navigate(-1)}
              >
                X
              </span>
            </div>
            <div className="flex flex-col m-3">
              <InfoRow data={element.id} label={"ID"} about="id" />
              <InfoRow
                data={element.full_name}
                label={"Full Name"}
                about="full_name"
              />
              <InfoRow data={element.email} label={"Email"} about="email" />
              <InfoRow
                data={element.address}
                label={"Address"}
                about="address"
              />
              <InfoRow
                data={element.postal_code}
                label={"Postal Code"}
                about="postal_code"
              />
              <InfoRow
                data={element.date_of_birth}
                label={"Data of Birth"}
                about="data_of_birth"
              />
              <InfoRow data={element.gender} label={"Gender"} about="gender" />
              <InfoRow data={element.phone} label={"Phone"} about="phone" />
              <InfoRow
                data={element.school_name}
                label={"School Name"}
                about="school_name"
              />
              <InfoRow
                data={element.test_center_name}
                label={"Test Center Name"}
                about="test_center_name"
              />
              <EnrollmentLetterField
                studentId={element.id}
                initialValue={element.enrollment_letter_received}
                fileName={element.enrollment_letter_file}
                assignedUser={element.enrollment_letter_assigned_user}
              />
              <TopAchieverField
                studentId={element.id}
                initialValue={element.top_achievers}
                initialFee={element.top_achievers_fee}
              />

              {/* <div className="p-2 border rounded mt-1 bg-blue-50">
                <InfoRow
                  data={element.act1_id}
                  label={"ACT 1 ID"}
                  about="act1_id"
                />
                <InfoRow
                  data={element.exam_name}
                  label={"Exam Name"}
                  about="exam_name"
                />
                <InfoRow
                  data={element.act1_score1}
                  label={"Score 1"}
                  about="act1_score1"
                />
                <InfoRow
                  data={element.act1_score2}
                  label={"Score 2"}
                  about="act1_score2"
                />
                <InfoRow
                  data={element.act1_score3}
                  label={"Score 3"}
                  about="act1_score3"
                />
                <InfoRow
                  data={element.act1_try_date1}
                  label={"Trial Date 1"}
                  about="act1_try_date1"
                />
                <InfoRow
                  data={element.act1_try_date2}
                  label={"Trial Date 2"}
                  about="act1_try_date2"
                />
                <InfoRow
                  data={element.act1_try_date3}
                  label={"Trial Date 3"}
                  about="act1_try_date3"
                />
                <InfoRow
                  data={element.act1_try_date4}
                  label={"Trial Date 4"}
                  about="act1_try_date4"
                />
                <InfoRow
                  data={element.act1_try_date5}
                  label={"Trial Date 5"}
                  about="act1_try_date5"
                />
                <InfoRow
                  data={element.act1_copy_number}
                  label={"Copies Number"}
                  about="act1_copy_number"
                />
                <InfoRow
                  data={element.act1_moe_copy}
                  label={"MOE Copies Number"}
                  about="act1_moe_copy"
                />
              </div> */}
              <div className="p-2 border rounded mt-1 bg-blue-50">
                {/* --- Static Info - These remain the same --- */}
                <InfoRow
                  data={element.act1_id}
                  label={"ACT 1 ID"}
                  about="act1_id"
                />
                <InfoRow
                  data={element.exam_name}
                  label={"Exam Name"}
                  about="exam_name"
                />

                {/* --- Dynamic Scores & Dates Section --- */}
                {/* 
                                                  We now loop through the 'scores' array.
                                                  The backend method returns this as an array of objects.
                                                  Each object represents one trial.
                                              */}
                {/* Render ACT1 scores grouped by trial_no from flat array */}
                {Array.isArray(element.act1_scores) && element.act1_scores.length > 0 ? (
                  (() => {
                    // Define the correct subject order
                    const SUBJECT_ORDER = ['English', 'Reading', 'Math', 'Science'];

                    // Group by trial_no robustly (avoid duplicate trials)
                    const grouped = new Map();
                    element.act1_scores.forEach((item) => {
                      const tno = item.trial_no;
                      if (!grouped.has(tno)) {
                        grouped.set(tno, {
                          trial_no: tno,
                          trial_id: item.trial_id,
                          trial_date: item.trial_date,
                          total_score: item.total_score,
                          subjects: []
                        });
                      }
                      grouped.get(tno).subjects.push({
                        subject_name: item.subject_name,
                        subject_score: item.subject_score
                      });
                    });

                    // Sort subjects within each trial by the correct order
                    grouped.forEach((trial) => {
                      trial.subjects.sort((a, b) => {
                        const orderA = SUBJECT_ORDER.indexOf(a.subject_name);
                        const orderB = SUBJECT_ORDER.indexOf(b.subject_name);
                        // If subject not found in order array, put it at the end
                        return (orderA === -1 ? 999 : orderA) - (orderB === -1 ? 999 : orderB);
                      });
                    });

                    // Render each trial only once
                    return Array.from(grouped.values()).map((scoreTrial, index) => (
                      <div key={scoreTrial.trial_no || index} className="p-2 my-2 border rounded bg-white shadow-sm">
                        <h4 className="font-bold text-md mb-2 text-blue-800 border-b pb-1">
                          Trial {scoreTrial.trial_no}
                        </h4>
                        <InfoRow
                          data={scoreTrial.total_score}
                          label={"Total Score"}
                          about={`act1_total_score_${scoreTrial.trial_no}`}
                        />
                        <InfoRow
                          data={scoreTrial.trial_date}
                          label={"Trial Date"}
                          about={`act1_trial_date_${scoreTrial.trial_no}`}
                        />
                        {/* If there are subject scores, display them */}
                        {Array.isArray(scoreTrial.subjects) && scoreTrial.subjects.length > 0 && (
                          <div className="mt-2 pl-4 border-l-2 border-blue-200">
                            <h5 className="font-semibold text-sm text-gray-600 mb-1">Subject Details:</h5>
                            {scoreTrial.subjects.map((subject, subIndex) => (
                              <InfoRow
                                key={subIndex}
                                data={subject.subject_score}
                                label={subject.subject_name}
                                about={`act1_subject_${String(subject.subject_name).toLowerCase()}_${scoreTrial.trial_no}`}
                              />
                            ))}
                          </div>
                        )}
                      </div>
                    ));
                  })()
                ) : (
                  <p className="p-2 text-gray-500">No trial scores found for ACT 1.</p>
                )}

                {/* --- Static Info - These remain the same --- */}
                <InfoRow
                  data={element.act1_copy_number}
                  label={"Copies Number"}
                  about="act1_copy_number"
                />
                <InfoRow
                  data={element.act1_moe_copy}
                  label={"MOE Copies Number"}
                  about="act1_moe_copy"
                />
              </div>
              {element.act2 && (
                <div className="p-2 border rounded mt-1 bg-green-50">
                  <InfoRow
                    data={element.act2_id}
                    label={"ACT 2 ID"}
                    about="act2_id"
                  />
                  <InfoRow
                    data={element.act2_score1}
                    label={"Score 1"}
                    about="act2_score1"
                  />
                  <InfoRow
                    data={element.act2_score2}
                    label={"Score 2"}
                    about="act2_score2"
                  />
                  <InfoRow
                    data={element.act2_score3}
                    label={"Score 3"}
                    about="act2_score3"
                  />
                  <InfoRow
                    data={element.act2_try_date1}
                    label={"Trial Date 1"}
                    about="act2_try_date1"
                  />
                  <InfoRow
                    data={element.act2_try_date2}
                    label={"Trial Date 2"}
                    about="act2_try_date2"
                  />
                  <InfoRow
                    data={element.act2_try_date3}
                    label={"Trial Date 3"}
                    about="act2_try_date3"
                  />
                  <InfoRow
                    data={element.subject1}
                    label={"Subject 1"}
                    about="subject1"
                  />
                  <InfoRow
                    data={element.subject2}
                    label={"Subject 2"}
                    about="subject2"
                  />
                  <InfoRow
                    data={element.subject3}
                    label={"Subject 3"}
                    about="subject3"
                  />
                  <InfoRow
                    data={element.act2_copy_number}
                    label={"Copies Number"}
                    about="act2_copy_number"
                  />
                  <InfoRow
                    data={element.act2_moe_copy}
                    label={"MOE Copies Number"}
                    about="act2_moe_copy"
                  />
                </div>
              )}
            </div>
            {studentType === "delivery_hold" && (holdComment || holdReason) && (
              <div className="p-3 m-3 border rounded bg-yellow-50">
                <h3 className="font-bold text-lg text-yellow-800 mb-2">Delivery Hold Info</h3>
                {holdReason && (
                  <InfoRow data={holdReason} label={"Reason"} about="delivery_hold_reason" />
                )}
                {holdComment && (
                  <InfoRow data={holdComment} label={"Comment"} about="delivery_hold" />
                )}
              </div>
            )}
            {studentType === "deliver_onsite" && (
              <div className="p-3 m-3 border rounded bg-yellow-50">
                <h3 className="font-bold text-lg text-yellow-800 mb-2">Delivery Hold Info</h3>
                {holdReason ? (
                  <InfoRow data={holdReason} label={"Reason"} about="delivery_hold_reason" />
                ) : (
                  <p className="text-gray-500 italic">No reason</p>
                )}
                {holdComment ? (
                  <InfoRow data={holdComment} label={"Comment"} about="delivery_hold" />
                ) : (
                  <p className="text-gray-500 italic">No comment</p>
                )}
              </div>
            )}
            <div className="py-3 text-center">
              {showSuccessAlert && <AlertSuccess text={text} />}
              {showDengerAlert && <AlertDenger text={text} />}
              {studentType === "delivery_hold" ? (
                <div>
                  {(!holdComment || !holdReason) && (
                    <p className="text-red-600 font-semibold text-sm mb-3 bg-red-50 border border-red-200 rounded p-2">
                      Note: You must add a Comment and Reason before forwarding. Click "Comment" to add them.
                    </p>
                  )}
                  <div className="flex flex-wrap justify-between p-2">
                    <div className="p-2">
                      <Button
                        color="bg-green-500 disabled:bg-gray-300"
                        onClick={handleForwardOnsite}
                        disabled={loading1 || !holdComment || !holdReason}
                        text={!loading1 ? "Forward to Deliver Onsite" : <Loading />}
                      />
                    </div>
                    <div className="p-2">
                      <Button
                        color="bg-green-500 disabled:bg-gray-300"
                        onClick={handleForwardAramex}
                        disabled={loading3 || !holdComment || !holdReason}
                        text={!loading3 ? "Forward to Deliver By Aramex" : <Loading />}
                      />
                    </div>
                    <div className="p-2">
                      <Button
                        color="bg-green-700"
                        onClick={openModal}
                        text="Comment"
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="flex flex-wrap justify-between p-2">
                  <div className="p-2">
                    <Button
                      color="bg-green-500 disabled:bg-gray-300"
                      onClick={openReceiverModal}
                      disabled={loading2}
                      text={!loading2 ? "Forward To MOHE Validation" : <Loading />}
                    />
                  </div>
                  {studentType === "deliver_onsite" && (
                    <div className="p-2">
                      <Button
                        color="bg-green-500 disabled:bg-gray-300"
                        onClick={handleForwardAramex}
                        disabled={loading3}
                        text={!loading3 ? "Forward to Deliver By Aramex" : <Loading />}
                      />
                    </div>
                  )}
                  {(studentType === "deliver_onsite" ||
                    studentType === "aramex") && (
                    <div className="p-2">
                      <Button
                        color="bg-yellow-500 disabled:bg-gray-300"
                        onClick={handleReturnToHold}
                        disabled={loading4}
                        text={!loading4 ? "Return to Delivery Hold" : <Loading />}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {showReceiverModal && (
        <MoheReceiverModal
          onClose={() => setShowReceiverModal(false)}
          onSubmit={handleForward}
          loading={loading2}
          error={receiverError}
        />
      )}

      {/* Delivery Hold Comment Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-lg mx-4 p-6">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold">Delivery Hold - Comment & Reason</h2>
              <span
                className="cursor-pointer rounded-full w-8 h-8 bg-red-400 text-white 
                  flex items-center justify-center active:scale-90 hover:bg-red-500 text-sm"
                onClick={() => setShowModal(false)}
              >
                X
              </span>
            </div>

            {modalError && (
              <div className="mb-3">
                <AlertDenger text={modalError} />
              </div>
            )}

            <label className="font-semibold mb-1 block">Reason <span className="text-red-500">*</span></label>
            <select
              className="bg-gray-100 rounded-lg p-2 outline-blue-700 border w-full mb-4"
              value={modalReason}
              onChange={(e) => setModalReason(e.target.value)}
            >
              <option value="">-- Select a Reason --</option>
              <option value="Don't Respond">Don't Respond</option>
              <option value="Missed Receiving Date">Missed Receiving Date</option>
              <option value="Received Successfully">Received Successfully</option>
              <option value="Request Shipping">Request Shipping</option>
              <option value="Other Reason">Other Reason</option>
            </select>

            <label className="font-semibold mb-1 block">Comment <span className="text-red-500">*</span></label>
            <textarea
              rows="5"
              placeholder="Write a comment here..."
              className="bg-gray-100 rounded-lg resize-none p-2 outline-blue-700 border w-full mb-4"
              value={modalComment}
              onChange={(e) => setModalComment(e.target.value)}
            ></textarea>

            <Button
              text={!modalLoading ? "Save" : <Loading />}
              color="bg-blue-500 disabled:bg-gray-300 w-full"
              disabled={modalLoading}
              onClick={handleSaveComment}
            />
          </div>
        </div>
      )}
    </div>
  );
}
